var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Ruleset is configuration as set of rules that will apply only to models that fullfill provided rules. ")]),_c('code',[_vm._v("\n        {\n            \"name\": \"John Doe\"\n        }\n    ")]),_c('p'),_c('p',[_vm._v(" This ruleset will only cover models that have field name equal to "),_c('code',[_vm._v("\"John Doe\"")])])])
}]

export { render, staticRenderFns }